export * from "./PromoCardVertical";
